export default __webpack_public_path__ + "static/website_visualize-321db9a87fef859db33b3156f2c62872.png";